module.exports = __webpack_public_path__ + "img/college3.1f26a5dc.png";